// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.succss-modal .el-dialog__header{\n  border-top: 4px solid #3855F1;\n}\n", ""]);
// Exports
module.exports = exports;
